/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

._flex_l41ly_157 {
  display: flex;
}

._justify-content-space-between_l41ly_161 {
  justify-content: space-between;
}

._tabular-nums_l41ly_165 {
  font-variant-numeric: tabular-nums;
}

@keyframes _show_l41ly_1 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Text styles */
._content_l41ly_178 ._header_l41ly_178 ._title_l41ly_178 h3 {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  font-size: 20px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  color: #1a1818;
}

._content_l41ly_178 ._header_l41ly_178 ._title_l41ly_178 h4 {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  color: #1a1818;
}

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

._flex_l41ly_157 {
  display: flex;
}

._justify-content-space-between_l41ly_161 {
  justify-content: space-between;
}

._tabular-nums_l41ly_165 {
  font-variant-numeric: tabular-nums;
}

@keyframes _show_l41ly_1 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Text styles */
._content_l41ly_178 ._header_l41ly_178 ._title_l41ly_178 h3 {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  font-size: 20px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  color: #1a1818;
}

._content_l41ly_178 ._header_l41ly_178 ._title_l41ly_178 h4 {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  color: #1a1818;
}

._content_l41ly_178 {
  padding: 1.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
._content_l41ly_178 ._header_l41ly_178 {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
._content_l41ly_178 ._header_l41ly_178 ._title_l41ly_178 {
  display: flex;
  flex-direction: column;
}
._content_l41ly_178 ._header_l41ly_178 ._title_l41ly_178 h3 {
  margin: 0.5rem 0 0.5rem 0.5rem;
  color: #2e426d;
}
._content_l41ly_178 ._header_l41ly_178 ._title_l41ly_178 h4 {
  margin: 0 0 0.5rem 0.5rem;
  color: #8f8d91;
}
._content_l41ly_178 ._header_l41ly_178 ._select_l41ly_451 {
  margin-left: auto;
}

._TopPostsSection_l41ly_455 ._content_l41ly_178 ._main_l41ly_455 {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
._TopPostsSection_l41ly_455 ._content_l41ly_178 ._main_l41ly_455 ._item_l41ly_462 {
  margin-right: 1rem;
  flex-shrink: 0;
  width: 10rem;
  display: flex;
  flex-direction: column;
}
._TopPostsSection_l41ly_455 ._content_l41ly_178 ._main_l41ly_455 ._item_l41ly_462:last-of-type {
  margin-right: 0;
}
._TopPostsSection_l41ly_455 ._content_l41ly_178 ._main_l41ly_455 ._item_l41ly_462 ._imageSection_l41ly_472 {
  margin-bottom: 0.5rem;
  width: 10rem;
  height: 10rem;
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
  border-radius: 0.25rem;
  will-change: box-shadow, transform;
  transition: box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1), transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
._TopPostsSection_l41ly_455 ._content_l41ly_178 ._main_l41ly_455 ._item_l41ly_462 ._imageSection_l41ly_472:hover {
  transform: translateY(-0.125rem);
  box-shadow: rgba(0, 0, 0, 0.16) 0rem 0.1875rem 0.625rem, rgba(0, 0, 0, 0.23) 0rem 0.1875rem 0.625rem;
}
._TopPostsSection_l41ly_455 ._content_l41ly_178 ._main_l41ly_455 ._item_l41ly_462 ._imageSection_l41ly_472 ._image_l41ly_472 {
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center top;
  border-radius: 0.25rem;
}
._TopPostsSection_l41ly_455 ._content_l41ly_178 ._main_l41ly_455 ._item_l41ly_462 ._imageSection_l41ly_472 ._profileImage_l41ly_494 {
  left: 1rem;
  bottom: -1.25rem;
  width: 2.5rem;
  height: 2.5rem;
  position: absolute;
  border-radius: 0.125rem;
  border: 0.125rem solid #fdfdfd;
}
._TopPostsSection_l41ly_455 ._content_l41ly_178 ._main_l41ly_455 ._item_l41ly_462 ._info_l41ly_503 {
  flex: 1;
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
  color: #8f8d91;
}
._TopPostsSection_l41ly_455 ._content_l41ly_178 ._main_l41ly_455 ._item_l41ly_462 ._info_l41ly_503 ._likes_l41ly_510 {
  text-align: right;
  margin-bottom: 0.5rem;
}
._TopPostsSection_l41ly_455 ._content_l41ly_178 ._main_l41ly_455 ._item_l41ly_462 ._info_l41ly_503 ._infoItem_l41ly_514 {
  margin-bottom: 0.25rem;
  display: flex;
  flex-direction: row;
  align-items: center;
}
._TopPostsSection_l41ly_455 ._content_l41ly_178 ._main_l41ly_455 ._item_l41ly_462 ._info_l41ly_503 ._infoItem_l41ly_514 ._type_l41ly_520 {
  color: #8f8d91;
}
._TopPostsSection_l41ly_455 ._content_l41ly_178 ._main_l41ly_455 ._item_l41ly_462 ._info_l41ly_503 ._infoItem_l41ly_514 ._count_l41ly_523 {
  margin-left: auto;
  color: #3996e0;
}